import { useEffect, useState } from 'react';
import Button from '../ui/Button.jsx';
import { Card, CardBody, CardFooter, CardHeader } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

const TIMER_SECOND = 20;

const Yesno = ({ ...props }) => {
    const { uid, heading, subheading, text, inputs, action } = props;
    const { formData, fn } = props;
    const [counter, setCounter] = useState(TIMER_SECOND);

    useEffect(() => {
        if (counter <= 0) {
            setCounter(TIMER_SECOND);
            addFormData(subheading, null);
            fn.handleAction(action);
        }

        const countdownInterval = setInterval(() => {
            setCounter((prevCounter) => prevCounter - 1);
        }, 1000);
        return () => clearInterval(countdownInterval);
    }, [counter]);

    const handleClickAnswer = (name, value) => {
        setCounter(TIMER_SECOND);
        addFormData(name, value);
        fn.handleAction(action);
    };

    const addFormData = (name, value) => {
        fn.handleFormChange({ ...formData, [name]: value });
    };

    return (
        <div className="component-yesno">
            <HeadingOne heading={heading} />
            <Card>
                <CardHeader>
                    <div className="row items-center justify-between">
                        <div className="col w-auto">
                            <h2 className="card-title">{subheading}</h2>
                        </div>
                        <div className="col w-auto">
                            <div>{counter}s</div>
                        </div>
                    </div>
                </CardHeader>
                <CardBody>
                    <div className="row justify-center">
                        <div className="col text-center lg:w-10/12">{text}</div>
                    </div>
                </CardBody>
                <CardFooter justify="center">
                    {inputs?.map((item, index) => (
                        <Button key={index} type={item.variant} onClick={() => handleClickAnswer(uid, item.value)}>
                            {item.title}
                        </Button>
                    ))}
                </CardFooter>
            </Card>
        </div>
    );
};

export default Yesno;
